export interface WSPayload {
  type: string;
  status?: "Ok" | "Error";
  server_log?: string;
  payload?: {
    payload_type: string;
    payload_data: any;
    payload_sender: string;
    payload_recipient: string;
  };
}

export class WebSocketClient {
  private ws: WebSocket | null = null;
  private onMessage: (ev: any) => void = (_ev) => {};
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private url: string;
  private needReconnect = false;
  private connected = false;
  private onOpenWS = () => {};
  private onCloseWS = () => {};
  private onErrorWS = () => {};

  constructor(url: string) {
    this.url = url;
  }

  setOnOpen(func: () => Promise<void> | void) {
    this.onOpenWS = func;
  }
  setOnClose(func: () => void) {
    this.onCloseWS = func;
  }
  setOnError(func: () => void) {
    this.onErrorWS = func;
  }
  setOnMessage(func: (ev: any) => void) {
    this.onMessage = func;
  }

  connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.needReconnect = true;
      this.ws = new WebSocket(this.url);

      this.ws.onopen = () => {
        this.reconnectAttempts = 0;
        this.onOpenWS();
        this.connected = true;
        resolve();
      };

      this.ws.onerror = (error) => {
        this.connected = false;
        this.onErrorWS();
        reject(error);
      };
      this.ws.onclose = () => {
        this.connected = false;
        this.onCloseWS();
        this.handleReconnect();
      };
      this.ws.onmessage = (event) => this.onMessage(event);
    });
  }

  setURL(URL: string, useWSS: boolean) {
    const wsUrl = `${useWSS ? "wss://" : "ws://"}${URL}`;
    this.url = wsUrl;
  }

  disconnect() {
    this.ws?.close();
    this.needReconnect = false;
    this.ws = null;
  }

  send(message: object | string) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message));
    }
  }

  isConnected() {
    return this.connected && (this.ws?.readyState === WebSocket.OPEN || this.ws?.readyState === WebSocket.CONNECTING);
  }

  private handleReconnect() {
    if (!this.needReconnect) return;

    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      setTimeout(() => {
        this.reconnectAttempts++;
        this.connect();
      }, 3000);
    }
  }
}
